<ul *ngIf="collapsed && data.menu && data.menu.length > 0" [@submenu]="expanded
      ? {value: 'visible',
          params: {transitionParams: '400ms cubic-bezier(0.86, 0, 0.07, 1)', height: '*'}}
      : {value: 'hidden',
          params: {transitionParams: '400ms cubic-bezier(0.86, 0, 0.07, 1)', height: '0'}}" class="sublevel-nav">
    <li *ngFor="let item of data.menu" class="sublevel-nav-item">
        <a class="sublevel-nav-link" (click)="handleClick(item)" *ngIf="item.menu && item.menu.length > 0"
            [ngClass]="getActiveClass(item)">
            <mat-icon class="sidenav-link-icon">{{item.icon}}</mat-icon>
            <span class="sublevel-link-text" @fadeInOut *ngIf="collapsed">{{'menu.'+item.text | localize}}</span>
            <em *ngIf="item.menu && collapsed" class="menu-collapse-icon"
                [ngClass]="!item.expanded ? 'fal fa-angle-right' : 'fal fa-angle-down'"></em>
        </a>
        <a class="sublevel-nav-link" *ngIf="!item.menu || (item.menu && item.menu.length === 0)"
            [routerLink]="[item.link]" routerLinkActive="active-sublevel"
            [routerLinkActiveOptions]="{exact: true}">
            <mat-icon class="sidenav-link-icon">{{item.icon}}</mat-icon>
            <span class="sublevel-link-text" @fadeInOut *ngIf="collapsed">{{'menu.'+item.text | localize}}</span>
        </a>
        <div *ngIf="item.menu && item.menu.length > 0">
            <app-sublevel-menu [data]="item" [collapsed]="collapsed" [multiple]="multiple"
                [expanded]="item.expanded"></app-sublevel-menu>
        </div>
    </li>
</ul>
